import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppInterfaceConfig, AppThemePalette, BrandState } from "@interfaces/theme";

const initialState: BrandState = {
  id: "",
  name: "",
  code: "",
  palette: null,
  interface: null,
  loading: false,
  error: null,
  display_name: "",
};

export const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    setBrandConfig: (
      state,
      action: PayloadAction<{
        id: string;
        name: string;
        code: string;
        palette: AppThemePalette;
        interface: AppInterfaceConfig;
        display_name: string;
      }>,
    ) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.code = action.payload.code;
      state.palette = action.payload.palette;
      state.interface = action.payload.interface;
      state.display_name = action.payload.display_name;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setBrandConfig, setLoading } = brandSlice.actions;
export default brandSlice.reducer;
